export default "__VITE_ASSET__CsoTke51__"